/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Buy_LifetimeInputs */

const en_landing_pricing_buy_lifetime = /** @type {(inputs: Landing_Pricing_Buy_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy once`)
};

const zh_landing_pricing_buy_lifetime = /** @type {(inputs: Landing_Pricing_Buy_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次买断`)
};

/**
* | output |
* | --- |
* | "Buy once" |
*
* @param {Landing_Pricing_Buy_LifetimeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_buy_lifetime = /** @type {((inputs?: Landing_Pricing_Buy_LifetimeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Buy_LifetimeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_buy_lifetime(inputs)
	return zh_landing_pricing_buy_lifetime(inputs)
});
export { landing_pricing_buy_lifetime as "landing.pricing.buy_lifetime" }